import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Briefcase, FileDown } from "lucide-react";
import { toast } from "sonner";

const eur = (v) => Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
const METHODS = ["Contante", "Assegno", "Bancomat", "Bonifico"];

export const CompanyTotalsCard = ({ sheet, groups, cognome }) => {
  if (!groups?.length) return null;
  const download = async (g) => {
    try {
      const res = await api.get(`/cash-sheets/${sheet.id}/pdf`, { params: { compagnia_id: g.compagnia_id || "" }, responseType: "blob" });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `foglio_cassa_${cognome || ""}_${sheet.data_foglio_cassa}_${g.nome.toLowerCase().replace(/[^a-z0-9]+/g, "_")}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <Card className="border-slate-200 overflow-hidden" data-testid="company-totals-card">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2">
        <Briefcase className="w-4 h-4 text-slate-600" />
        <h3 className="font-heading font-semibold text-slate-900">Foglio diviso per compagnia</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 uppercase text-[11px]">
            <tr>
              <th className="text-left px-4 py-2">Compagnia</th>
              <th className="text-right px-3 py-2">Righe</th>
              {METHODS.map((m) => <th key={m} className="text-right px-3 py-2">{m}</th>)}
              <th className="text-right px-3 py-2">Liquidità</th>
              <th className="text-right px-3 py-2">Totale</th>
              <th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {groups.map((g) => (
              <tr key={g.compagnia_id || "none"} data-testid={`company-row-${g.compagnia_id || "none"}`}>
                <td className="px-4 py-2 font-medium text-slate-900">{g.nome}</td>
                <td className="px-3 py-2 text-right font-mono-num">{g.totals.count_totale}</td>
                {METHODS.map((m) => <td key={m} className="px-3 py-2 text-right font-mono-num">{eur(g.totals[m])}</td>)}
                <td className="px-3 py-2 text-right font-mono-num">{eur(g.totals.totale_liquidita)}</td>
                <td className="px-3 py-2 text-right font-mono-num font-semibold">{eur(g.totals.totale_generale)}</td>
                <td className="px-3 py-2 text-right">
                  <Button size="sm" variant="ghost" onClick={() => download(g)} data-testid={`company-pdf-${g.compagnia_id || "none"}`}>
                    <FileDown className="w-4 h-4 mr-1" /> PDF
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
